// extracted by mini-css-extract-plugin
export var cartContainer = "_k7-4";
export var gray = "_k7-1";
export var itemContainer = "_k7-2";
export var itemDetails = "_k7-3";
export var strong = "_k7-0";